export const Image_Url = {
    TVSADMIN: '/img/TVSADMIN.jpeg',
    TVSADMIN1: '/img/TVSADMIN1.jpeg',
    SEARCH:'/img/search.svg',
    TruChamp:'/img/truchamp.jpeg',
    EDIT:'/img/edit.svg',
    TruChamp:'/img/truchamp.jpg',
    TVSLOGO:'/img/tvs_logo.svg',
    PGMLIST:'/img/PGM List.svg',
    REWARD:'/img/Reward Catalogue.svg',
    QUERY:'/img/Query.svg',
    FAQ:'/img/FAQ.svg',
    TRAINING:'/img/Training.svg',
    CREATETRAINING:'/img/Create Training.svg',
    VIEWTRAINING:'/img/View Training.svg',
    SHOP:'/img/shop.jpeg',
    DELETE_ICONS:"/img/deleteicons.svg",
    PLUS:"/img/plus.svg",
    MINUS:"/img/minus.svg",
    EXCEL_LOGO:"/img/Excel_icon.svg",
    DOWNLOAD_APPPLE:"/img/downloadApple.svg",
    DOWNLOAD_GOOGLE:"/img/downloadGoogle.svg"
}